﻿"use strict";
export function clickHeaderPrev() {
    jQuery(".headerButtons-prev").click(function () {
        if (!!(window.history && history.pushState)) {
            window.history.back();
        } else {
            window.history.back();
        }
    });
}